// mutations of the state happens here
import types from './mutation-types'

export default {
  [types.FETCH_PRODUCTS_PENDING](state) {
    state.productsLoading = true
  },
  [types.FETCH_PRODUCTS_SUCCESS](state) {
    state.productsLoading = false
  },
  [types.FETCH_PRODUCTS_FAILURE](state) {
    state.productsLoading = false
  },
  [types.LOAD_PRODUCTS](state, products) {
    state.productList = products
    state.productsLoaded = true
  },
  [types.LOAD_PRODUCTS_TMP](state, response) {
    state.productPagination = response.pagination
    state.products = response.data
    state.productsLoaded = true
  },
  [types.UPDATE_PARAMS](state, payload) {
    // here object assign is used to merge values from payload into filterParams
    // if key exists in filterParams, payload overwrite with new value
    // if key does not exist, value will not be updated
    // this is handy for pagination where for instance &per_page=10 should exist on
    // all calls. This way we won't need to send pagination when updating &query= for instance
    Object.assign(state.filterParams, payload)
  },
  [types.SET_DATELIST](state, dateList) {
    state.dateList = dateList
  },
  [types.SET_SELECTED_DATE](state, date) {
    state.selectedDate = date
  },
  [types.SET_DELETED_PRODUCT](state, productId) {
    state.deletedProducts.push(productId)
  },
}
